/* jshint esversion: 6 */


const setInputDefaults = function(input, type, userPerms, routeType) {
    let constants = this.props.app.config.constants;

    input.id = new Date().getTime();
    input.rID = -1;
    input.pullFreq = userPerms.resources.pullFrequencyList[0];
    input.numItems = 10;
    input.postLimit = 100;
    input.activeFlag = 1;
    input.preferSummary = constants.BODY_PREFER_SUMMARY;
    input.filterBehavior = 1;
    input.filtersTitle = 1;
    input.filtersContent = 1;
    input.postFlag = constants.POST_NOW;
    input.firstPullFlag = constants.FIRSTPULL_SINGLE;
    input.postImages = 1;
    input.defaultGeo = [];
    input.sched = [];
    input.rules = [];
    input.attrs = {
        prefixText: '',
        prefixSpace: 0,
        postfixText: '',
        postfixSpace: 0,
        repost: [],
        hashTags: {
            hashPlacement: constants.HASH_POST,
            hashStatic: [],
            hashPool: [],
            poolNum: 0,
            poolActive: 0
        },
        autoHash: 0,
        autoHashNum: 2,
        autoHashSpaces: 0,
        autoHashSource: 1
    };
    input.valid = null;
    input.routeType = (routeType) ? routeType : constants.R_DEFAULT;

    if (routeType && routeType == constants.R_CURATE_BASIC) {
        input.firstPullFlag = constants.FIRSTPULL_ON;
        input.pullFreq = 30;
    }

    switch (parseInt(type, 10)) {
        case constants.INPUT_TYPE_FEED:
            input.type = constants.INPUT_TYPE_FEED;
            input.pushEnabled = 1;
            break;

        case constants.INPUT_TYPE_TWITTER:
            input.type = constants.INPUT_TYPE_TWITTER;
            input.attrs.type = constants.TWITTER_TYPE_USER;
            input.attrs.exclude_replies = 0;
            input.attrs.include_rts = 0;
            if (this.props.isAgencyUser(userPerms.permbits.pub_level) || this.props.isPlusUser(userPerms.permbits.pub_level) || this.props.isAgencyPlusUser(userPerms.permbits.pub_level)) {
                input.pullFreq = 5;
            } else {
                input.pullFreq = 15;
            }
            if (input.username) {
                input.attrs.user_name = "@" + input.username;
                input.name = "@" + input.username;
            }
            break;

        case constants.INPUT_TYPE_INSTAGRAM_BUSINESS:
            input.type = constants.INPUT_TYPE_INSTAGRAM_BUSINESS;
            if (input.username) {
                input.name = input.username;
            }
            input.socialOverrides = {};
            input.socialOverrides.postStyle = constants.SOC_OVRD_STYLE_MEDIA;
            input.socialOverrides.postText = constants.SOC_OVRD_TEXT_BOTH;
            input.attrs.typeFilter = constants.INPUT_SOURCE_FILTER_FEED + constants.INPUT_SOURCE_FILTER_REELS;
            break;

        case constants.INPUT_TYPE_FACEBOOK_PAGE:
            input.type = constants.INPUT_TYPE_FACEBOOK_PAGE;
            if (input.username) {
                input.name = input.username + " Posts";
            }
            input.socialOverrides = {};
            input.socialOverrides.postStyle = constants.SOC_OVRD_STYLE_MEDIA;
            input.socialOverrides.postText = constants.SOC_OVRD_TEXT_BOTH;
            input.attrs.typeFilter = constants.INPUT_SOURCE_FILTER_FEED + constants.INPUT_SOURCE_FILTER_REELS;
            break;

        case constants.INPUT_SUBTYPE_PINTEREST:
            input.type = constants.INPUT_TYPE_FEED;
            input.subtype = constants.INPUT_SUBTYPE_PINTEREST;
            input.subtypeUsername = '';
            input.subtypeBoard = '';
            break;

        case constants.INPUT_TYPE_TIKTOK:
            input.type = constants.INPUT_TYPE_TIKTOK;
            if (input.username) {
                input.name = input.username + " Posts";
            }
            input.socialOverrides = {};
            input.socialOverrides.postStyle = constants.SOC_OVRD_STYLE_MEDIA;
            input.socialOverrides.postText = constants.SOC_OVRD_TEXT_BOTH;
            break;

        case constants.INPUT_TYPE_YOUTUBE:
            input.type = constants.INPUT_TYPE_YOUTUBE;
            if (input.username) {
                input.name = input.username + " Posts";
            }
            input.socialOverrides = {};
            input.socialOverrides.postStyle = constants.SOC_OVRD_STYLE_LINK;
            input.socialOverrides.postText = constants.SOC_OVRD_TEXT_BOTH;
            break;

    }

};

export default setInputDefaults;
